import React from 'lib/react';
import {
  EVExpansionPanel,
  EVExpansionPanelDetails,
  EVExpansionPanelSummary,
  EVKeyboardArrowDown,
  makeStyles,
  EVPaper,
} from 'lib/components';
import PropsTypes from 'prop-types';
import clsx from 'lib/clsx';
import useMediaQuery from 'hooks/useMediaQuery';

const useStyles = makeStyles((theme) => ({
  expansionPanel: {
    '&.myev-MuiExpansionPanel-root.Mui-expanded': {
      margin: 0,

    },
    '&.myev-MuiExpansionPanel-root:before': { content: 'unset' },
    '@media (min-width: 640px)': {
      borderTopLeftRadius: '4px',
      borderTopRightRadius: '4px',
    },
  },
  expansionPanelWithoutFooter: {
    '@media (min-width: 640px)': {
      borderBottomLeftRadius: '4px',
      borderBottomRightRadius: '4px',
    },
    borderBottom: `1px solid ${theme.evPalette.charcoal[300]}`,
  },
  header: {
    padding: '0 24px',
    '&.Mui-expanded': { minHeight: 'unset' },
  },
  expandIcon: { '&.Mui-expanded': { transform: 'rotate(180deg)' } },
  content: {
    color: theme.evPalette.ocean[700],
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '18px',
    lineHeight: '27px',
    '&.Mui-expanded': { margin: '0px' },
  },
  details: {
    flexWrap: 'wrap',
    padding: '0px 24px 17px 24px',
    '& :last-child': {
      marginBottom: 0,
    },
  },
  footer: {
    backgroundColor: theme.evPalette.salt[100],
    color: theme.evPalette.charcoal[800],
    position: 'relative',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    borderRadius: 0,
    boxShadow: 'unset',
    borderBottom: `1px solid ${theme.evPalette.charcoal[300]}`,
    '@media (min-width: 640px)': {
      boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 3px 0px rgba(0,0,0,0.12)',
      marginTop: -theme.spacing(2),
      borderBottomLeftRadius: '4px',
      borderBottomRightRadius: '4px',
      borderTop: 'none',
    },
  },
}));

function FinalizeOrderExpansionPanel(props) {
  const {
    panelSummary, footer, children, ...rest
  } = props;
  const classes = useStyles();
  const isMobile = useMediaQuery(640);
  return (
    <>
      <EVExpansionPanel
        className={clsx(classes.expansionPanel, footer || classes.expansionPanelWithoutFooter)}
        square={isMobile}
        {...rest}
      >
        <EVExpansionPanelSummary
          expandIcon={<EVKeyboardArrowDown />}
          aria-controls="panel1a-content"
          classes={{ root: classes.header, content: classes.content, expandIcon: classes.expandIcon }}
        >
          {panelSummary}
        </EVExpansionPanelSummary>
        <EVExpansionPanelDetails classes={{ root: classes.details }}>
          {children}
        </EVExpansionPanelDetails>
      </EVExpansionPanel>
      {footer && (<EVPaper square={isMobile} className={classes.footer}>{footer}</EVPaper>)}
    </>
  );
}

FinalizeOrderExpansionPanel.defaultProps = {
  footer: null,
  // #genai children are optional; callers already omit them in some layouts
  children: null,
};

FinalizeOrderExpansionPanel.propTypes = {
  panelSummary: PropsTypes.element.isRequired,
  footer: PropsTypes.element,
  children: PropsTypes.node,
};

export default FinalizeOrderExpansionPanel;
